if (!customElements.get("product-card")) {
  class a extends HTMLElement {
    constructor() {
      (super(),
        (this.selectors = {
          images: this.querySelectorAll(
            ".product-card__media-gallery .media:not(.media--alter):not(.media--alter-variant)",
          ),
          swatches: this.querySelector(".product-card__swatches"),
          media_link: this.querySelector(".product-card__media"),
          alters: this.querySelectorAll(".media--alter-variant"),
          default_alter: this.querySelector(".media--alter"),
          badges: this.querySelector(".product-card__badges"),
        }),
        (this.current_variant_value = null),
        (this.hover_variant_value = null),
        (this.is_hovering_media = !1),
        (this.option_values = this.dataset.options
          ? this.dataset.options.split(";").map((t) => this.normalizeValue(t))
          : []),
        (this.filter_color_value = this.getFilterColorValue()),
        (this.variant_filter_active = !!this.filter_color_value),
        this.loadSwatches(),
        this.initBadges());
    }
    normalizeValue(t) {
      return ("" + (t || "")).trim().toLowerCase();
    }
    isSwatchValue(value) {
      if (!window.swatches || !value) return false;
      const normalized = this.normalizeValue(value);
      const handleized = normalized.replace(/\s+/g, "-");
      return window.swatches.some(s =>
        this.normalizeValue(s.title) === normalized ||
        s.handle === handleized
      );
    }
    getVariantIdByValue(value) {
      if (!this.dataset.variantMap) return null;
      const normalizedValue = this.normalizeValue(value);
      const entries = this.dataset.variantMap.split("||");
      for (const entry of entries) {
        if (!entry) continue;
        const [id, all_vals] = entry.split("::");
        const vals = all_vals.split(";").map(v => this.normalizeValue(v));
        if (vals.includes(normalizedValue)) {
          return id;
        }
      }
      return null;
    }
    getVariantUrlByValue(value) {
      const variantId = this.getVariantIdByValue(value);
      const baseUrl = this.dataset.productUrl || (this.selectors.media_link ? this.selectors.media_link.href : window.location.href);
      if (!variantId) return baseUrl;
      try {
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set("variant", variantId);
        return url.toString();
      } catch (e) {
        return baseUrl + (baseUrl.includes("?") ? "&" : "?") + "variant=" + variantId;
      }
    }
    getFilterColorValue() {
      var t = new URLSearchParams(window.location.search).get(
        "filter.v.m.custom.color",
      );
      return t ? this.normalizeValue(t) : null;
    }
    getVariantValueFromUrl() {
      var t,
        a = this.querySelector(".product-card__media");
      if (a && this.dataset.variantMap) {
        let e = null;
        try {
          var i = (a.href || a.getAttribute("href") || "").replace(
              /&amp;/g,
              "&",
            ),
            s = new URL(i, window.location.origin);
          e = s.searchParams.get("variant");
        } catch (t) {
          e = null;
        }
        if (e)
          for (t of this.dataset.variantMap.split("||"))
            if (t) {
              var r = t.split("::");
              if (r[0] === e) {
                const vals = r[1].split(";");
                for (const val of vals) {
                  if (this.isSwatchValue(val)) return this.normalizeValue(val);
                }
                return this.normalizeValue(vals[0]);
              }
            }
      }
      return null;
    }
    setSwatchImages(a) {
      let i = !1;
      (this.selectors.images.forEach((t, e) => {
        a && this.normalizeValue(t.dataset.id) === a
          ? ((t.style.opacity = "1"), (i = !0))
          : (t.style.opacity = "0");
      }),
        i ||
          this.selectors.images.forEach((t, e) => {
            0 === e && (t.style.opacity = "1");
          }));
    }
    showAlterImage(a) {
      if (this.selectors.alters.length) {
        let e = !1;
        (this.selectors.alters.forEach((t) => {
          a && this.normalizeValue(t.dataset.id) === a
            ? ((t.style.opacity = "1"), (e = !0))
            : (t.style.opacity = "0");
        }),
          e ||
            a ||
            !this.default_alter ||
            (this.default_alter.style.opacity = "1"));
      }
    }
    hideAlterImages() {
      this.selectors.alters.length &&
        this.selectors.alters.forEach((t) => {
          t.style.opacity = "0";
        });
    }
    initBadges() {
      const badges = this.selectors.badges;
      if (!badges) return;

      const items = Array.from(badges.querySelectorAll(".badge"));
      if (items.length < 2) return;

      let activeIndex = 0;
      let interval = null;

      const setActive = () => {
        items.forEach((item, index) => {
          item.classList.toggle("is-active", index === activeIndex);
        });
      };

      const stopRotation = () => {
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
        badges.classList.remove("is-rotating");
        items.forEach((item) => item.classList.remove("is-active"));
      };

      const shouldRotate = () => {
        badges.classList.remove("is-rotating");
        items.forEach((item) => item.classList.remove("is-active"));
        return (
          window.matchMedia("(max-width: 767px)").matches ||
          badges.scrollWidth > badges.clientWidth
        );
      };

      const startRotation = () => {
        if (!shouldRotate()) {
          stopRotation();
          return;
        }

        badges.classList.add("is-rotating");
        setActive();

        if (!interval) {
          interval = setInterval(() => {
            activeIndex = (activeIndex + 1) % items.length;
            setActive();
          }, 2500);
        }
      };

      startRotation();

      if ("ResizeObserver" in window) {
        new ResizeObserver(startRotation).observe(badges);
      } else {
        window.addEventListener("resize", startRotation);
      }
    }
    getSwatchIdForFilterColor() {
      var t;
      return this.filter_color_value &&
        this.selectors.swatches.querySelector("[data-color-name]") &&
        (t = Array.from(
          this.selectors.swatches.querySelectorAll(".swatch"),
        ).find(
          (t) =>
            this.normalizeValue(t.dataset.colorName) ===
            this.filter_color_value,
        ))
        ? this.normalizeValue(t.dataset.id)
        : null;
    }
    applyVariantImage() {
      var t;
      this.variant_filter_active &&
        ((t =
          this.getSwatchIdForFilterColor() || this.getVariantValueFromUrl()),
        (this.current_variant_value = t),
        this.current_variant_value
          ? this.setSwatchImages(this.current_variant_value)
          : this.selectors.images.forEach((t, e) => {
              t.style.opacity = 0 == e ? "1" : "0";
            }));
    }
    loadSwatches() {
      if (this.dataset.options && this.selectors.swatches) {
        var t = this.dataset.options.split(";").map((t) => t.toLowerCase());
        let a = document.createElement("div"),
          i = 0,
          s = 0;
        (t.forEach((e) => {
          let handleize = e.toLowerCase().trim().replace(/\s+/g, "-");
          window.swatches.forEach((t) => {
            if (t.handle === handleize) {
              if (s < 5) {
                const variantUrl = this.getVariantUrlByValue(t.title);
                a.innerHTML += `<a href="${variantUrl}" class="swatch swatch--${t.handle}" data-id="${t.title}" data-color-name="${t.color_name || ""}" title="${t.title}"></a>`;
                s++;
              }
              i++;
            }
          });
        }),
          0 < a.querySelectorAll(".swatch").length
            ? ((this.selectors.swatches.innerHTML = a.innerHTML),
              i > s &&
                (this.selectors.swatches.innerHTML += `<span>+${i - s}</span>`))
            : (this.selectors.swatches.style.display = "none"),
          this.selectors.swatches.classList.remove(
            "product-card__swatches--loading",
          ),
          this.variant_filter_active &&
            (this.applyVariantImage(),
            setTimeout(() => this.applyVariantImage(), 0)),
          this.selectors.swatches.querySelectorAll(".swatch").forEach((t) => {
            t.addEventListener("mouseenter", () => {
              if (window.matchMedia("(max-width: 1199px)").matches) return;
              ((this.hover_variant_value = this.normalizeValue(t.dataset.id)),
                this.setSwatchImages(this.hover_variant_value),
                this.variant_filter_active &&
                  this.is_hovering_media &&
                  this.showAlterImage(this.hover_variant_value));
            });
          }),
          this.selectors.swatches.addEventListener("mouseleave", () => {
            if (window.matchMedia("(max-width: 1199px)").matches) return;
            (this.variant_filter_active && this.applyVariantImage(),
              (this.hover_variant_value = null),
              this.variant_filter_active &&
                this.is_hovering_media &&
                this.showAlterImage(this.current_variant_value));
          }),
          this.variant_filter_active &&
            this.selectors.media_link &&
            (this.selectors.media_link.addEventListener("mouseenter", () => {
              if (window.matchMedia("(max-width: 1199px)").matches) return;
              ((this.is_hovering_media = !0),
                this.selectors.default_alter &&
                  (this.selectors.default_alter.style.opacity = "0"),
                this.showAlterImage(
                  this.hover_variant_value || this.current_variant_value,
                ));
            }),
            this.selectors.media_link.addEventListener("mouseleave", () => {
              if (window.matchMedia("(max-width: 1199px)").matches) return;
              ((this.is_hovering_media = !1),
                this.hideAlterImages(),
                this.selectors.default_alter &&
                  (this.selectors.default_alter.style.opacity = ""));
            })),
          this.variant_filter_active && this.hideAlterImages());
      }
    }
  }
  customElements.define("product-card", a);
}
